import axiosClient from "./client";

export const login = (login: { email: string; password: string }) => {
    return axiosClient.post(`/app/auth/login`, login).then((response) => response);
};
